var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"addbtncontent"},[_c('div',{staticClass:"add-btn",on:{"click":_vm.addbtnClick}},[_c('span',{staticClass:"plus"},[_vm._v("+")]),_c('span',[_vm._v(_vm._s(_vm.value))])]),(_vm.isShowSpan)?_c('span',[_vm._v("请选择PDF格式文件上传")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }